import Tooltip from '../base/Tooltip'
import Image from 'next/image'
import COMPANY_CHECKED from './assets/checked.svg'
import { useTranslation } from '../../hooks/useTranslation'
const TooltipVerified = () => {
  const { translate } = useTranslation()
  return (
    <Tooltip className="tooltip-company-verify" title={translate('page_companies:company_verify')}>
      <Image src={COMPANY_CHECKED} alt="company-verify" width={16} height={16} />
    </Tooltip>
  )
}

export default TooltipVerified
